// import TopHeader from "../../../../components/general/TopHeader";
// import DashboardInverterData from "../dashboard/dashboardTabs/tab5Content/DashboardInverterData";
// import PlantLogData from "../plantPowerCurve/plantLogTabs/PlantLogData";
// import SupportForm from "./SupportForm";

// export default function SupportFormMain() {
//     return (
//         <>
//             <TopHeader />
//             <div className="container-fluid mt-2">
//                 <div className="row">
//                     <div className="col-md-6 p-2">
//                         <PlantLogData />
//                     </div>

//                     <div className="col-md-6 p-2">
//                         <SupportForm />
//                     </div>
//                 </div>
//             </div>
//         </>

//     );
// }


import TopHeader from "../../../../components/general/TopHeader";
import PlantLogData from "../plantPowerCurve/plantLogTabs/PlantLogData";
import SupportForm from "./SupportForm";
import { Box, Paper, Typography } from "@mui/material";
import SupportList from "./SupportFormTable/SupportFormTable";

export default function SupportFormMain() {
  return (
    <>
      <TopHeader />

      <div className="container-fluid mt-3">
        <div className="row g-3">

          {/* LEFT CARD : PLANT LOG DATA */}
          <div className="col-md-6">
            <Paper
              elevation={8}
              sx={{
                height: "100%",
                borderRadius: 4,
                // p: 2,
                bgcolor: "#ffffff",
                display: "flex",
                flexDirection: "column",
              }}
            >
             

              <Box sx={{ flex: 1, overflow: "auto" }}>
                <SupportList/>
              </Box>
            </Paper>
          </div>

          {/* RIGHT CARD : SUPPORT FORM */}
          <div className="col-md-6">
            <Paper
              elevation={8}
              sx={{
                height: "100%",
                borderRadius: 4,
                // p: 2,
                bgcolor: "#ffffff",
                display: "flex",
                flexDirection: "column",
              }}
            >
             

              <Box sx={{ flex: 1 }}>
                <SupportForm />
              </Box>
            </Paper>
          </div>

        </div>
      </div>
    </>
  );
}

